export default "__VITE_ASSET__B_fLNIv2__"